export const cardTitle = {
  margin: "1.875rem 0 1.25rem",
  fontWeight: 700,
  fontSize: 18,
  lineHeight: "1.5rem",
  color: "#fff",
};

export const cardContent = {
  lineHeight: "1.625rem",
  color: "#FAFAFA",
  opacity: ".7",
};
